export default {

    init() {
        console.log('init work...');
		this.bindEvents();
    },

    bindEvents() {
        $('#content').on('click', '[data-js="loadmore"]', this.handleLoadMore);
    },

	handleLoadMore(e) {
		e.preventDefault();

		let $button = $(this);
		let $container = $('#results');
		let url = $button.attr('href');

		$button.text('Loading...').addClass('disabled').on('click', function() { return false; });

		$.get(url, function(data) {
			let $data = $(data);

			$container.append($data.find('#results').contents());
			$container.next('#pager').replaceWith($data.find('#pager'));

			Work.updateUrl(url);
		});

	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

};